import React, { useEffect, useState } from "react";
import Style from "./VHCInstallationPage.module.css";
import { ReactComponent as AppStore } from "../../../assets/svg/app_store.svg";
import { ReactComponent as GooglePlay } from "../../../assets/svg/google_play.svg";
import { ReactComponent as VHCCertificate } from "../../../assets/svg/vhc_certificate.svg";
import { ReactComponent as VHCScanning } from "../../../assets/svg/vhc_scanning.svg";
import { ReactComponent as VHCLogo } from "../../../assets/svg/vhc-logo.svg";
import logo from "../../../assets/Bosch_DigitalLogo_BlackAnchor_144x96px.png";
import { Image } from "semantic-ui-react";
import VHCMobileLandingPage from "./Mobile/LandingPage";
import Footer from "./Footer/Footer";

const VHCInstallationPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  const maxMobileWidth = 932;//768;

  function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor;
    if (
      userAgent.match(/iPad/i) ||
      userAgent.match(/iPhone/i) ||
      userAgent.match(/iPod/i)
    ) {
      return "iOS";
    } else if (userAgent.match(/Android/i)) {
      return "Android";
    } else if (userAgent.match(/Windows/i)) {
      return "Windows";
    }
    return "unknown";
  }

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= maxMobileWidth);
    window.addEventListener("resize", handleResize);
    
    let appURL = "";
    switch (getMobileOperatingSystem()) {
      case "Android":
        appURL = process.env.REACT_APP_BVHC_MOBILE_APP_CHPLAY_URL || "";
        break;
      case "iOS":
        appURL = process.env.REACT_APP_BVHC_MOBILE_APP_APPSTORE_URL || "";
        break;
      default:
        break;
    }

    if (appURL || window.innerWidth <= maxMobileWidth) {
      setIsMobile(true);
      //window.location.href = appURL;
    }

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const openMobileStore = (mobileOperationSystem: string): void => {
    let appUrl = "";
    switch (mobileOperationSystem) {
      case "Android":
        appUrl = process.env.REACT_APP_BVHC_MOBILE_APP_CHPLAY_URL || "";
        break;
      case "iOS":
        appUrl = process.env.REACT_APP_BVHC_MOBILE_APP_APPSTORE_URL || "";
        break;
      default:
        break;
    }

    if (appUrl) window.location.href = appUrl;
  };

  if (isMobile) {
    return <VHCMobileLandingPage />;
  }

  return (
    <>
      <div className={Style.container}>
        <div className={Style.logo}>
          <Image className="logo-image" src={logo}></Image>
        </div>
        <div className={Style.outer_ellipse}>
          <div className={Style.inner_ellipse}>{/* <Ellipse_36 /> */}</div>

          <div className={Style.scanning}>
            <VHCScanning />
          </div>
          <div className={Style.certificate}>
            <VHCCertificate />
          </div>
          <div className={Style.information}>
            <p>Validate your</p>
            <p>Bosch Vehicle</p>
            <p>Health Certificate</p>
            <div className={Style.vhc_logo}>
              <VHCLogo />
            </div>
            <p>Download now</p>
            <div className={Style.downloadButton}>
              <AppStore onClick={() => openMobileStore("iOS")} />
              <GooglePlay onClick={() => openMobileStore("Android")} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
};
export default VHCInstallationPage;
